export function replaceAll(str: string, find: string, replace: string): string {
    return str.replace(new RegExp(find, "g"), replace);
}

export function capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatAddress(streetName: string, streetNumber: string, cityName: string, provinceAcronym?: string): string {

    const components: Array<string> = [];

    if (streetName && streetName !== "ND") {
        if (streetNumber && streetNumber !== "ND" && streetNumber !== "0")
            components.push(`${streetName} ${streetNumber}`);
        else
            components.push(streetName);
    }

    if (cityName && provinceAcronym) {
        components.push(`${cityName} (${provinceAcronym})`);
    } else {
        components.push(cityName);
    }

    const address = components.filter((component: string) => !!component).join(", ");

    return capitalizeFirstLetter(address);
}

export function decodeTextWithEntities(strWithEntities: string | null): string {
    if (!strWithEntities)
        return ""

    const a = document.createElement("span");
    a.innerHTML = strWithEntities;
    return a.textContent || "";
}


/**
 * Replaces a given string with the values of the object
 * @param str string to replace
 * @param mapObj Object whose keys are the tokens to replace and whose values are the ones that will replace that matched token
 * e.g. replaceAllToken('Here we go', {Here: Now, go: eat}) returns 'Now we eat'
 * */
export function replaceAllTokens(str: string, mapObj: Record<string, string>): string {
    const re = new RegExp(Object.keys(mapObj)
        .map(key => key.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"))
        .join("|"), "gi");
    return str.replace(re, function (matched) {
        return mapObj[matched.toLowerCase()];
    });
}

export function cleanASCII(str: string): string {
    return str.replace(/[\uA78C\uA78B]/g, "'").replace(/[^\x00-\x7F]/g, "");
}
